module.exports = __webpack_public_path__ + "img/money-cny-box-line.de0d1fb3.svg";